var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReferenceMultipleSelect',{staticClass:"ma-0",attrs:{"label":"Страна прибытия","resource":"countries"},on:{"input":_vm.changeArrivalCountries},model:{value:(_vm.destinationCountries),callback:function ($$v) {_vm.destinationCountries=$$v},expression:"destinationCountries"}})
}
var staticRenderFns = []

export { render, staticRenderFns }